import React from 'react';
interface SectionHeadingProps {
  id: string;
  eyebrow?: string;
  children: React.ReactNode;
  /** Light sections use dark text; dark sections use white text. */
  tone?: 'light' | 'dark';
  align?: 'left' | 'center';
  intro?: React.ReactNode;
}
export function SectionHeading({
  id,
  eyebrow,
  children,
  tone = 'dark',
  align = 'center',
  intro
}: SectionHeadingProps) {
  const isDark = tone === 'dark';
  return <div className={align === 'center' ? 'mx-auto max-w-3xl text-center' : 'max-w-3xl'} data-id="element-184" data-mp="bleqtin1u0ye">
      {eyebrow && <p className={`text-xs font-bold uppercase tracking-[0.18em] ${isDark ? 'text-gold' : 'text-gold-dark'}`} data-id="element-185" data-mp="gi56w5yuswjt">
          {eyebrow}
        </p>}
      <h2 id={id} className={`mt-3 font-display text-[2.4rem] font-extrabold leading-[0.95] sm:text-6xl ${isDark ? 'text-white' : 'text-copy-dark'}`} data-id="element-186" data-mp="6tn79s2b8vhr">
        {children}
      </h2>
      {intro && <p className={`mt-4 text-base leading-relaxed sm:text-lg ${isDark ? 'text-copy-light' : 'text-copy-muted'}`} data-id="element-187" data-mp="zapx1fn64njx">
          {intro}
        </p>}
    </div>;
}